<!-- ParentComponent.vue -->
<style scoped>
.add-email-form {
  position: relative;
}
.account-type, .nav-buttons {
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  padding-top: 20px;
}
.account-type a {
  text-decoration: none;
  color: grey;
}
.nav-buttons .btn,
.account-type .btn {
  margin: 10px;
}
.edit-hover span {
  color: black !important;
}
.close {
  font-size: 12px;
  position: absolute;
  right: 0px;
  top: 30px;
}
input {
  border: 1px solid #ced4da;
}
.smtp-title {
  color: grey;
}
</style>

<template>
  <div class="container smtp-emails">
    <div class="row nav-buttons">
      <button v-if="emails.length" class="btn btn-secondary apply-btn-color compose-email-btn"
              @click="hideAddEmailOptions">
        {{ $t('list_all_emails') }}
      </button>

      <button class="btn btn-secondary apply-btn-color add-email-btn"
              @click="initAddEmailForm">
        {{ $t('add_new_email') }}
      </button>

      <button v-if="emails.length" class="btn btn-primary apply-btn-color compose-email-btn"
              @click="initComposeEmail">
        {{ $t('compose') }}
      </button>

      <button v-if="showSend" class="btn btn-dark" @click="sendEmail">
        {{ $t('send') }}
      </button>
    </div>

    <div v-if="!compose">
      <div v-if="addNew" class="add-email-form">
        <div class="account-type">
        </div>
        <div class="row text-center account-type">
          <div class="col-4">
            <a href="/email/google">
              <h3>
                <img src="/images/webmail/btn_google_signin_light_normal_web@2x.png" height="70" alt="">
              </h3>
            </a>
          </div>
          <div class="col-4">
            <a href="/email/microsoft">
              <h3>
                <i class="fab fa-microsoft"></i> {{ $t('microsoft_account') }}
              </h3>
            </a>
          </div>
          <div class="col-4">
            <a href="#" @click="initOtherEmailForm">
              <h3>
                <i class="fa fa-server" aria-hidden="true"></i> {{ $t('SMTP') }}
              </h3>
            </a>
          </div>
        </div>
        <div v-if="addGmail" class="mt-2">
          {{ $t('login_with') }} <a href="/email/google">Google</a>
        </div>
        <div v-if="addSMTP" class="mt-2">
          <div class="text-center smtp-title">
            <h4>{{ $t('smpt_details') }}</h4>
          </div>
          <div>
            <add-emails @success="hideAddEmailOptions"></add-emails>
          </div>
        </div>
      </div>
      <div v-if="!addNew && emails.length && !editEmail" class="mt-4">
        <email-list @delete="deleteEmail" @edit="editEmailFunction" :emails="emails"></email-list>
      </div>
      <div v-if="editEmail" class="mt-4">
        <edit-email :email-id="editID" @success="handleSuccess"></edit-email>
      </div>
    </div>
    <div v-if="compose" class="compose-email">
      <composer-email @showSend="toggleSendButton"></composer-email>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import bootbox from 'bootbox';

export default {
  data: function () {
    return {
      compose: false,
      addNew: false,
      addGmail: false,
      addSMTP: false,
      showSend: false,
      emails: [],
      editEmail: false,
      editID: null
    };
  },
  mounted: function () {
    this.getUserEmails('onLoad');
  },
  methods: {
    sendEmail: function (e) {
      $('#submit-email-modal').trigger('click');
    },
    toggleSendButton(action) {
      this.showSend = action;
    },
    getUserEmails(initFrom = '') {
      axios.get('/user/emails')
          .then(res => {
            this.emails = res.data;
            if (initFrom === 'onLoad') {
              let action = this.getUrlParameter('action');
              if (action === 'compose' && this.emails.length) {
                this.compose = true;
              } else if (action === 'compose') {
                this.addNew = true;
              }
            }
          });
    },
    initAddEmailForm(e) {
      e.preventDefault();
      this.addNew = true;
      this.compose = false;
      this.editEmail = false;
    },
    initGoogleEmailForm(e) {
      e.preventDefault();
      this.addGmail = true;
      this.addSMTP = false;
    },
    initOtherEmailForm(e) {
      e.preventDefault();
      this.addGmail = false;
      this.addSMTP = true;
    },
    hideAddEmailOptions(e) {
      if (e) { e.preventDefault(); }
      this.addNew = false;
      this.addGmail = false;
      this.addSMTP = false;
      this.compose = false;
      this.editEmail = false;
      this.getUserEmails();
    },
    handleSMTPFormSubmit(e) {
      e.preventDefault();
    },
    deleteEmail(email) {
      // Immediately disable the delete button

      if(email.is_deleting){
        bootbox.alert('Deletion in progress, please wait!');
        return;
      }

      email.is_deleting = true;

      // Make the delete request
      axios.delete('/user/email', {
        params: { id: email.id }
      }).then(res => {
        if (res.data) {
          this.getUserEmails();  // Refresh the list of emails after deletion
        }
      }).catch(err => {
        // If the request fails, re-enable the delete button
        email.is_deleting = false;
        // Optionally handle errors here
      });
    },
    initComposeEmail(e) {
      e.preventDefault();
      this.compose = true;
    },
    getUrlParameter(name) {
      name = name.replace(/[\[]/, '\\[').replace(/[\]]/, '\\]');
      let regex = new RegExp('[\\?&]' + name + '=([^&#]*)'),
          results = regex.exec(location.search);
      return results === null ? '' : decodeURIComponent(results[1].replace(/\+/g, ' '));
    },
    editEmailFunction(emailID) {
      this.editID = emailID;
      this.editEmail = true;
      this.addNew = false;
      this.compose = false;
    },
    handleSuccess() {
      this.editEmail = false;
      this.editID = null;
      this.getUserEmails();
    }
  }
};
</script>
